"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reviver = exports.replacer = void 0;
const replacer = (key, value) => {
    if (value instanceof Map) {
        return {
            dataType: 'Map',
            value: Array.from(value.entries()),
        };
    }
    else {
        return value;
    }
};
exports.replacer = replacer;
const reviver = (key, value) => {
    if (typeof value === 'object' && value !== null) {
        if (value.dataType === 'Map') {
            return new Map(value.value);
        }
    }
    return value;
};
exports.reviver = reviver;
//# sourceMappingURL=serialization.js.map